import React from "react";
import { Layout } from "antd";
import SideBar from "../../../components/SideBar/container";
import Analysis from "./Analysis";

const { Header, Content, Footer } = Layout;

function ResultDocument(props) {
  let data = Object.keys(props.answers)
    .map(answer => {
      if (props.answers[answer].category === props.highlight) {
        return {
          ...props.answers[answer],
          own: props.answers[answer].value,
          key: props.answers[answer].title,
          peer1: props.peer1 && props.peer1[answer].value,
          peer2: props.peer2 && props.peer2[answer].value,
          peer3: props.peer3 && props.peer3[answer].value
        };
      }
      
      return null;
    })
    .filter(item => !!item);
  return (
    <Layout style={{ height: "100vh" }}>
      <SideBar />
      <Layout>
        <Header
          style={{
            textAlign: "left",
            background: "#fff",
            padding: "0 24px",
            borderBottom: "1px solid"
          }}
        >
          <h1 style={{ display: "inline-block" }}>
            {props.author.fullName}'s survey
          </h1>
        </Header>
        <Content style={{ backgroundColor: "#001529" }}>
          <Analysis
            data={data}
            highlight={props.highlight}
            language={props.language}
            ownName={props.author.fullName}
            peer1Name={props.result && props.result.peer1Name}
            peer2Name={props.result && props.result.peer2Name}
            peer3Name={props.result && props.result.peer3Name}
            changeAnalysisTab={props.changeAnalysisTab}
            loading={props.loading}
          />
        </Content>
        <Footer style={{ textAlign: "center" }}>iLead © 2018</Footer>
      </Layout>
    </Layout>
  );
}

export default ResultDocument;



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultDocument/index.js